export enum NodeCategory {
    FlowControl = "flow_control",
    DataOperations = "data_operations",
    Connections = "connections",
    Composition = "composition",
}

export enum NodeType {
    // Flow control
    Wait = "waitNode",
    Repeater = "repeaterNode",
    Breaker = "breakerNode",

    // Data operations
    Modify = "modifyFieldNode",
    Set = "setNode",

    // Connections
    Http = "httpNode",
    Webhook = "webhookNode",

    // Composition (SubScenario, Mirror, End, Start)
    SubScenario = "subScenarioNode",
    Mirror = "mirrorNode",
    End = "endNode",
    Start = "startNode",

    // Methods (empty placeholder node)
    Methods = "methodsNode",
}

// Flow types for Start node badge
export type StartFlowType = "post" | "ping" | "postVerify" | "webhook" | "instant";

export enum StepOutcome {
    Success = "success",
    Failed = "failed",
}
